import { Component, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { NavController, NavParams, App, Searchbar } from 'ionic-angular';
//Pages
import { AtividadePage } from '../../pages/atividade/atividade';
import { PalestrantePerfilPage } from '../../pages/palestrante-perfil/palestrante-perfil';
import { BuscaPage } from '../../pages/busca/busca';
//Components
import { CustomAlert } from '../custom-alert.component';
//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { SearchProvider } from '../../providers/search-provider';
import { LecturerProvider } from '../../providers/lecturer-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
//Models
import { Congresso } from '../../models/congresso.model';
import { User } from '../../models/user.model';
import { SearchModel } from '../../models/search.model';
import { Lecturer } from '../../models/lecturer.model';
import { DayProgram } from '../../models/day-program.model';

@Component({
    selector: 'custom-searchbar',
    templateUrl: 'custom-searchbar.html'
})
export class CustomSearchbar {
    @ViewChild(Searchbar) searchbar;
    @Output() search: EventEmitter<any> = new EventEmitter();

    public program: SearchModel= new SearchModel();
    public atividadesDia: DayProgram[];
    public palestrantes: Lecturer[];
    public user: User;
    public congresso: Congresso;
    public isCurrent: boolean;

    private icon: any;

    constructor(private navControler: NavController,
        public navParams: NavParams,
        private configProvider: ConfigProvider,
        private searchProvider: SearchProvider,
        private utilProvider: UtilProvider,
        private palestrantesProvider: LecturerProvider,
        private congressoProvider: CongressoProvider,
        private app: App) {
        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.isCurrent = this.congresso.Ano == configProvider.ANO_ATUAL || this.congresso.Liberado;
    }

    onInput(term:any){
        this.utilProvider.searchTerm = term.target.value? term.target.value : "";
        if(!this.user) this.user = localStorage.getItem('user')? JSON.parse(localStorage.getItem('user')) as User: null;
        
        if(this.utilProvider.searchTerm != ""){
            if(localStorage.getItem('atividadesDia') && localStorage.getItem('palestrantes')){
                this.redirect(BuscaPage);
            }
            else if(!localStorage.getItem('atividadesDia') && !localStorage.getItem('palestrantes')){
                this.searchProvider.getSearch(this.user? this.user.Guid: "", this.congresso.Ano).
                    then(data => {
                        localStorage.setItem('atividadesDia', data.AtividadesDia ? JSON.stringify(data.AtividadesDia) : '');
                        localStorage.setItem('palestrantes', data.Palestrantes? JSON.stringify(data.Palestrantes) : '');
                        this.redirect(BuscaPage);
                    })
                    .catch((e)=>{ console.log(e); });
            }
            else if(!localStorage.getItem('atividadesDia')){
                    this.searchProvider.getSearch(this.user? this.user.Guid: "", this.congresso.Ano)
                        .then(data => {
                            localStorage.setItem('atividadesDia', data.AtividadesDia ? JSON.stringify(data.AtividadesDia) : '');
                            this.redirect(BuscaPage);
                        })
                        .catch((e)=>{ console.log(e); });
            }
            else if(!localStorage.getItem('palestrantes')){
                this.palestrantesProvider.getPalestrantes(this.congresso.Ano, this.user? this.user.Guid: "")
                    .then(data => {
                        localStorage.setItem('palestrantes', data? JSON.stringify(data) : '');
                        this.redirect(BuscaPage);
                    })
                    .catch((e)=>{ console.log(e); });
            }
        }
    }

    redirect(page: any){
        var hasSearch = false;
        var currentViewindex = this.navControler.getViews().length-1;
        
        this.navControler.getViews().forEach((view, index) =>{
            if(view.component == page){
                hasSearch = true;
                this.search.emit(null);
                if(index < currentViewindex)
                    this.navControler.pop(page);
            }
        });
        if(!hasSearch)
            this.navControler.push(page);
        
        this.search.emit();
    }

    onBlur(){
        this.utilProvider.searchInFocus = false;
        this.showIcon();
    }

    OnFocus(event:any){
        this.utilProvider.searchInFocus = true;
        this.hiddeIcon(event);
    }

    setFocus(){
        this.searchbar.setFocus();
    }

    hiddeIcon(event: any){
        var icon = this.searchbar._searchbarIcon.nativeElement;
        if(event.target.value != "")
            icon.hidden = true
    }

    showIcon(){
        var icon = this.searchbar._searchbarIcon.nativeElement;
        if(icon.hidden)
            icon.hidden = false;
    }
}


// WEBPACK FOOTER //
// ./src/components/custom-searchbar/custom-searchbar.ts